import React, { useEffect, useState } from 'react';
interface LocationData {
  city: string;
  region: string;
  country: string;
  isLoading: boolean;
  error: string | null;
}
export const useLocation = (): LocationData => {
  const [locationData, setLocationData] = useState<LocationData>({
    city: 'New York',
    region: '',
    country: '',
    isLoading: true,
    error: null
  });
  useEffect(() => {
    const fetchLocation = async () => {
      try {
        const response = await fetch('https://ipinfo.io/json', {
          headers: {
            Accept: 'application/json'
          }
        });
        if (!response.ok) {
          throw new Error('Failed to fetch location data');
        }
        const data = await response.json();
        setLocationData({
          city: data.city || 'New York',
          region: data.region || '',
          country: data.country || '',
          isLoading: false,
          error: null
        });
      } catch (error) {
        console.error('Error fetching location:', error);
        setLocationData({
          city: 'New York',
          region: '',
          country: '',
          isLoading: false,
          error: error instanceof Error ? error.message : 'Unknown error'
        });
      }
    };
    fetchLocation();
  }, []);
  return locationData;
};